const uiSettings = require('./utils/UISettings');
const Helpers = require('./mcd-postcode-check-helpers');

const Analytics = require('./analytics');
const Product = require('./product');

const collectInStore = require('./collect-in-store');

const LocationService = require('./locationservice');
const LocationStatus = require('./locationstatus');
const ProductAvailability = require('./productavailability');

let wrapper = null;
let currentLocation = null;

function initElementWrappers(channelsPanel) {

  const locationSearchWrapper = channelsPanel.find('.check-delivery-options');
  const mcdTabs = channelsPanel.next('.mcd-tabs');
  const mcdTabsController = mcdTabs.find('.tabs');

  const mcdTabsList = mcdTabsController.find('a');
  const channels = channelsPanel.find('.prd-channels');
  const feedbacks = mcdTabs.find('.mcd-feedback');

  const deliverySlotsEl = mcdTabs.find('.delivery-slot-picker');
  const infoBox = mcdTabs.find('.hd-postcode-info');
  const postcodeNewSelection = infoBox.find('#pc-for-new-selection');
  const postcodeItemsInBasket = infoBox.find('#pc-for-items-in-basket');

  const form = channelsPanel.find('form.postcode-checker');
  const loader = form.find('.mcd-loader').hide();
  const techError = form.prevAll('.error-feedback');
  const help = form.find('.help');

  const safetyStepEl = mcdTabs.find('.delivery-safety-step');
  const showDeliveryBtn = safetyStepEl.find('.bt');
  const freeDeliveryAddToBasketButtonPanel = mcdTabs.find('.free-delivery');
  const checkCollectInsteadSafetyStep = safetyStepEl.find('.pt10');
  const checkCollectInstead = mcdTabs.find('.check-collect-instead');
  const checkDeliveryInstead = mcdTabs.find('.check-delivery-instead');
  const deliverySlotsOffMsg = mcdTabs.find('.delivery-slots-disabled');
  const deliveryLoader = mcdTabs.find('.delivery-slots-loader');
  const tradeplaceUndeliverableElt = feedbacks.find('.mcd-tradeplace-undeliverable');
  const collectStoreAltElt = mcdTabs.find('.mcd-reserve-store-alt');

  const stickyFooter = $('#product-actions-toggle');
  const countdownPlaceholder = mcdTabs.find('.countdown-placeholder-mcd');
  const deliveryOffer = mcdTabs.find('.mcd-delivery-instead');

  mcdTabs.find('.change-location a').on('click', (event) => {
    LocationService.clearLocation(true);
    event.stopPropagation();
    event.preventDefault();
  });

  collectStoreAltElt.find('a').click((e) => {
    e.preventDefault();
    mcdTabsController.find('a.mcd-desktop-tab2').click();
  });

  mcdTabsList.last().on('click', () => {
    Analytics.track('collectInStoreDisplayed');
  });

  checkCollectInstead.find('a').click((e) => {
    e.preventDefault();
    mcdTabsList.filter('a.mcd-desktop-tab2').click();
  });

  checkDeliveryInstead.find('a').click((e) => {
    e.preventDefault();
    mcdTabsList.filter('a.mcd-desktop-tab1').click();
  });

  /** @param {Promise} cancellable
   @returns {Promise} */
  function beginAvailabilityRequest(cancellable) {
    if ($('.error-placeholder').css('display') === 'block') {
      return;
    }
    techError.add(help).hide();
    stickyFooter.hide();

    const request = new Promise(((resolve, reject) => {
      const productDelivery = document.querySelector('.check-delivery-options');
      const product = new Product(productDelivery.getAttribute('data-productid'));
      product.getAvailability(currentLocation, resolve, reject);
    }));

    return Promise.race([request, cancellable]).then( // eslint-disable-line consistent-return
      (result) => { // eslint-disable-line consistent-return
        if (result instanceof ProductAvailability) {
          // Resolved by ProductAvailability
          onAvailabilitySuccess(result);
          // dispatching of the data-layer redux action
          if (window.appState) {
            window.appState.dispatch({
              type: 'EVENTS_STOCK_AVAILABILITY',
              payload: {
                products: [{
                  productID: window.digitalData.product[0].productID,
                  productSKU: window.digitalData.product[0].productSKU,
                  productName: window.digitalData.product[0].productName,
                  availabilityStatus: `${result.getDeliveryState()}|${result.getCollectionState()}`
                }]
              }
            });
          }
        } else {
          // Resolved by Cancellable - probably a timeout
          return Promise.reject(new LocationStatus(LocationService.LocationState.TIMEOUT,
            'Timeout during gathering location'));
        }
      },
      (reason) => {
        let errorMessage = reason;
        // Rejected by API call
        if (!(typeof reason === 'string')) {
          errorMessage =
            window.App.locale.getFormattedString('component.locationsearch.locationerror',
              {
                location: LocationService.getLocation().location ||
                  LocationService.getLocation()
              });
        }
        return Promise.reject(
          new LocationStatus(LocationService.LocationState.ERROR, errorMessage)
        );
      }
    ).catch((reason) => {
      // report runtime errors thrown in availability-related code inside the promise
      console.error(reason);
    });

  }

  function resetAvailability() {
    mcdTabsList.removeClass('disabled');
    mcdTabsList.find('.dcg-icon-cross-reverse').remove();

    mcdTabs.add(help)
      .add(safetyStepEl)
      .add(tradeplaceUndeliverableElt)
      .add(collectStoreAltElt)
      .add(deliverySlotsEl)
      .add(infoBox)
      .add(deliverySlotsOffMsg)
      .hide();
    locationSearchWrapper.add(channelsPanel)
      .add(freeDeliveryAddToBasketButtonPanel)
      .add(checkCollectInstead)
      .show();
    // postcodeInputElt.focus();
    showDeliveryBtn.unbind('click');
    locationSearchWrapper.removeClass('postcode-error-state');
    countdownPlaceholder.show();
  }

  function disableTab(tab) {
    if (!tab.hasClass('disabled')) {
      tab.addClass('disabled');
    }
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function updateLocationFeedback(productAvailability) {

    let tabType;
    let tabLabel;
    let tabState;
    let labelElement;

    loader.add(locationSearchWrapper).add(channelsPanel).hide(); // hide spinner
    channelsPanel.show(); // show add to basket button and download button (whole channels box)

    feedbacks.each(function callback() {
      const feedback = $(this);

      if (feedback.parents('.tab').hasClass('mcd-desktop-tab1')) {
        tabType = 'tab1';
        tabLabel = productAvailability.getDeliveryLabel();
        tabState = productAvailability.getDeliveryState();
      } else {
        tabType = 'tab2';
        tabLabel = productAvailability.getCollectionLabel();
        tabState = productAvailability.getCollectionState();
      }

      // When no availability of both Home Delivery and
      // Collect at Store for postcode, hide tabs and display proper message
      if (productAvailability.isUndeliverablePostcode() &&
        productAvailability.isUnCollectablePostcode()) {
        mcdTabsList.filter('a.mcd-desktop-tab1').click();
        mcdTabsList.hide();
        checkCollectInstead.hide();
        labelElement = feedback.find('.emphase');
        tabLabel = labelElement.data('unavailable-postcode');
        mcdTabsList.parents('.tabs').addClass('disabled-tabs');
      } else {
        mcdTabsList.show();
        mcdTabsList.parents('.tabs').removeClass('disabled-tabs');
      }

      Helpers.updateFeedback(feedback, tabType, currentLocation.location, tabLabel,
        productAvailability.getAvailabilityInfo(), tabState);
    });

    // display tabs always (even for tradeplace)
    mcdTabs.show();
    mcdTabsList.filter('a.mcd-desktop-tab1').click();
    freeDeliveryAddToBasketButtonPanel.hide();
    countdownPlaceholder.hide();
  }

  /**
   * handles result for tradeplace
   * @param productAvailability
   */
  function updateTradeplaceProduct(productAvailability) {
    mcdTabsList.filter('a.mcd-desktop-tab1').click();
    disableTab(mcdTabsList.filter('a.mcd-desktop-tab2'));
    checkCollectInstead.hide();
    if (!productAvailability.isDeliverable() && productAvailability.getProductSegment()) {
      Helpers.setUndeliverableLinks(
        tradeplaceUndeliverableElt, productAvailability.getProductSegment()
      );
    }
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function updateUndeliverableProduct(productAvailability) {
    if (productAvailability.isUnDeliverable()) {
      mcdTabsList.filter('a.mcd-desktop-tab2').click();
      disableTab(mcdTabsList.filter('a.mcd-desktop-tab1'));
      checkDeliveryInstead.hide();
      deliveryOffer.hide();
    } else if (productAvailability.isUndeliverablePostcode()) {
      mcdTabsList.filter('a.mcd-desktop-tab1').click();
      deliveryLoader.hide();
      if (productAvailability.isCollectable()) {
        checkCollectInstead.hide();
        collectStoreAltElt.show();
        updateLocationFeedback(productAvailability);
      } else if (productAvailability.isUnCollectablePostcode()) {
        checkCollectInstead.hide();
      }
      freeDeliveryAddToBasketButtonPanel.hide();
    }
  }

  /** @param {ProductAvailability} productAvailability */
  /** @param {array<Object>} deliverySlots */
  /** @returns {void} */
  function updateProductDelivery(productAvailability, deliverySlots) {
    if (productAvailability.hasDeliverySlots()) {
      Helpers.updateProductDeliveriesSlot(
        productAvailability, deliverySlots,
        deliveryLoader, countdownPlaceholder, checkCollectInstead, postcodeNewSelection,
        postcodeItemsInBasket, infoBox, deliverySlotsEl, freeDeliveryAddToBasketButtonPanel
      );
    } else if (productAvailability.isUndeliverablePostcode()) {
      // This handles the special case when safety step is active and
      // in second call it becomes undeliverable to poscode for any reason
      updateLocationFeedback(productAvailability);
      updateUndeliverableProduct(productAvailability);
      countdownPlaceholder.hide();
    } else {
      mcdTabsList.filter('a.mcd-desktop-tab2').click();
      disableTab(mcdTabsList.filter('a.mcd-desktop-tab1'));
      checkDeliveryInstead.hide();
      deliveryOffer.hide();
    }
  }

  /** @param {string} message */
  /** @returns {void} */
  function onDeliveryError(message) {
    deliverySlotsEl.show();
    deliveryLoader.hide();
    Helpers.showMainError(
      channelsPanel, locationSearchWrapper, channels, techError, help, mcdTabs, loader
    );
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function offerProductDeliveryOptions(productAvailability) {
    mcdTabsList.filter('a.mcd-desktop-tab1').click();
    Helpers.offerProductDeliveryOptions(
      safetyStepEl, checkCollectInstead, countdownPlaceholder, showDeliveryBtn, deliverySlotsEl,
      freeDeliveryAddToBasketButtonPanel, deliveryLoader, productAvailability,
      updateProductDelivery, onDeliveryError
    );
  }

  /** @param {ProductAvailability} productAvailability */
  /** @returns {void} */
  function updateCollectInStore(productAvailability) {
    deliveryOffer.hide();
    collectInStore.clearStoresList();
    if (productAvailability.isCollectable()) {
      collectInStore.initialise(
        productAvailability.getAvailableStores(),
        productAvailability.isPayAndCollectFromStoreStockEnabled()
      );
      if (productAvailability.isUnDeliverable()) {
        checkDeliveryInstead.hide();
      }
    } else if (productAvailability.isUncollectable()) {
      disableTab(mcdTabsList.filter('a.mcd-desktop-tab2'));
      checkCollectInstead.hide();
      checkCollectInsteadSafetyStep.hide();
    } else if (productAvailability.isUncollectableOutOfStock() &&
      !productAvailability.isUnDeliverable()) {
      checkDeliveryInstead.show();
    } else if (productAvailability.isDeliverable()) {
      deliveryOffer.show().on('click', () => { mcdTabsList.filter('a.mcd-desktop-tab1').click(); });
    } else if (productAvailability.isUnCollectablePostcode()) {
      // no action
    } else {
      checkCollectInstead.hide();
    }
  }

  /**
   * handles the productAvailability result from the api and updates the UI
   * @param productAvailability
   * todo high cyclomatic complexity here
   */
  function onAvailabilitySuccess(productAvailability) {
    Helpers.trackAvailabilityAnalytics(productAvailability);

    updateLocationFeedback(productAvailability);

    if (productAvailability.isTradeplaceProduct()) {
      updateTradeplaceProduct(productAvailability);
    } else if (productAvailability.isDeliverable() === false) {
      updateUndeliverableProduct(productAvailability);
    } else if (productAvailability.hasDeliverySlots()) {
      productAvailability.getProductDelivery(updateProductDelivery, onDeliveryError);
    } else if (productAvailability.isDeliveryStepEnabled()) {
      offerProductDeliveryOptions(productAvailability);
    } else if (!productAvailability.hasDeliverySlots() &&
      productAvailability.getProductType() === 'SMALLBOX') {
      freeDeliveryAddToBasketButtonPanel.show();
    }
    updateCollectInStore(productAvailability);

    if (!productAvailability.hasDeliverySlots() &&
      !productAvailability.isTradeplaceProduct()) {
      deliverySlotsOffMsg.css('display', 'block');
    }

    // handle global setting for this particular product
    if (uiSettings.get('app.availability.default', uiSettings.Type.PAGE) === 'collect') {
      mcdTabsList.filter('a.mcd-desktop-tab2').click();
    }

    if (productAvailability.getDeliveryState() === 'UNDELIVERABLE_OUT_OF_STOCK') {

      const deliveriesContent = mcdTabs.find('.mcd-touch-tab1');

      Helpers.createUdeliverableOutOfStockContent(
        countdownPlaceholder, deliveriesContent, productAvailability
      );
    }

    if (productAvailability.isUndeliverablePostcode()) {
      countdownPlaceholder.hide();
    } else if (productAvailability.isDeliveryStepEnabled()) {
      countdownPlaceholder.hide();
    }

    // handle global setting for this particular product
    if (uiSettings.get('app.availability.default', uiSettings.Type.PAGE) === 'collect') {
      mcdTabsList.filter('a.mcd-desktop-tab2').click();
    }
  }

  return {
    beginAvailabilityRequest: beginAvailabilityRequest,
    resetAvailability: resetAvailability,
    onAvailabilitySuccess: onAvailabilitySuccess
  };

}

module.exports = {
  init: function() {
    // remove touch mcd tabs
    $('.mcd-tabs-touch').detach();

    const channelsPanel = $('[data-component="channels-panel"]');
    wrapper = initElementWrappers(channelsPanel);
  },

  /** @param {LocationDescriptor} location
   @param {Promise} cancellable
   @returns {Promise} */
  getProductAvailability: function(location, cancellable) {
    currentLocation = location;
    return wrapper.beginAvailabilityRequest(cancellable);
  },

  setLocationFeedback: function setLocationFeedback(productAvailability) {
    currentLocation = {
      location: productAvailability.getLocation(),
      postcode: productAvailability.getLocation()
    };
    return wrapper.onAvailabilitySuccess(productAvailability);
  },

  /** @returns {void} */
  clearProductAvailability: function() {
    wrapper.resetAvailability();
  }

};
